export class ListasReporte {
  pais: string[] = [];
  gerencia: string[] = [];
  area: string[] = [];
  lugar: string[] = [];
  vicepresidencia: string[] = [];
  tipo_conflicto: string[] = [];
  fecha_ini: string = '';
  fecha_fin: string = '';
}
